import { styled, css } from 'styled-components'
import { XIcon } from '../../icons'
import { onLargeScreen } from 'mixtiles-web-common'

export const CloseButton = styled(XIcon)`
  width: 32px;
  height: 32px;
  cursor: pointer;
  z-index: 1;
`

export const Header = styled.div`
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  margin: 50px auto 17px;
  opacity: 1;

  ${onLargeScreen()} {
    font-size: 24px;
  }

  ${({ $editing }) =>
    $editing &&
    css`
      opacity: 0;
      transition: opacity 0.5s;
    `}
`

export const Description = styled.div`
  width: 250px;
  color: ${({ theme }) => theme.colors.grayDark};
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 39px;
  opacity: 1;

  ${onLargeScreen()} {
    font-size: 18px;
    width: 276px;
  }

  ${({ $editing }) =>
    $editing &&
    css`
      opacity: 0;
      transition: opacity 0.5s;
    `}
`

export const DoneButton = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`

export const Cta = styled.div`
  padding: 20px 10px;
  box-shadow: 0px -4px 13px rgba(43, 5, 20, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;

  ${onLargeScreen()} {
    background: white;
  }

  ${({ $editing }) =>
    $editing &&
    css`
      opacity: 0;
      transition: opacity 0.5s;
    `}
`
